import { debounce, TextField } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { CompanyType } from "$types/CompanyType";
import { CompanyServices } from "$services";
import { queryClient } from "$utils/queryClient";
import { CacheInvalidationAction } from "$utils/cache";

type Props = {
  onChange: (val: any, ids?: any) => void;
  value: any;
  className?: string;
  disabled?: boolean;
  /**
   * @deprecated to be deleted when no more used by any other component
   */
  companyType?: CompanyType;
  clientId?: string;
  label?: string;
  placeholder?: string;
  orderModule?: boolean;
};
function CompanySearchInput({
  disabled,
  className,
  clientId,
  label = "Entreprise",
  placeholder = "Par nom",
  orderModule = false,
  value,
  onChange,
  ...props
}: Props) {
  const [localValue, setLocalValue] = useState(value);

  const setDebouncedChange = useMemo(() => debounce(onChange, 300), [onChange]);

  const getCompanies = async (newName) => {
    const filters = {
      ...{ name: newName },
    };
    try {
      const companies = await queryClient.fetchQuery(
        [CacheInvalidationAction.GET_COMPANIES, filters],
        () => CompanyServices.getCompanies(filters),
        { staleTime: 1000 * 60 }
      );
      return companies?.data;
    } catch (error) {
      return null;
    }
  };

  // Permet de répercuter l'update du companySideBarFilter !
  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  const handleChange = async (currentValue: string) => {
    setLocalValue(currentValue);
    const companies = await getCompanies(currentValue);
    setDebouncedChange(
      currentValue,
      companies.map((c) => c._id)
    );
  };

  return (
    <TextField
      placeholder={placeholder}
      className={className}
      disabled={disabled}
      value={orderModule ? localValue || "" : value}
      variant="outlined"
      type="text"
      onChange={(e: any) =>
        orderModule ? handleChange(e.target.value) : onChange(e)
      }
      label={label}
      style={{ width: "100%" }}
      {...props}
    />
  );
}

export default CompanySearchInput;
